import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { assignValueById } from 'utils/Activities/activitiesRemoveDuplicates';
import { useSchool } from '../../SchoolContext';
import { getActivityData } from '../../utils';
import ProfileSection from '../ProfileSection';
import styles from './styles.module.css';
import renderListOfActivitiesTypes from '../utils/renderListOfActivitiesTypes';

export default function InstalationsActivities({ isFetching }) {
  const { schoolData } = useSchool();
  const activities = getActivityData(schoolData || []) || [];
  const [useAllactivities, setUseAllActivities] = useState([]);
  const [instalationActivities, setInstalationActivities] = useState({});
  const [count, setCount] = useState(0);

  useEffect(() => {
    const loadActivities = async () => {
      if (!activities.length) return;

      const educationalFacilitiesActivities = {
        properties: await assignValueById(activities, 12),
        title: 'Instalaciones Educativas',
      };
      const playFacilitiesActivities = {
        properties: await assignValueById(activities, 13),
        title: 'Instalaciones Lúdicas',
      };
      const sportFAcilitiesActivities = {
        properties: await assignValueById(activities, 14),
        title: 'Instalaciones Deportivas',
      };
      const healthAndDevelopmentInstalationsActivities = {
        properties: await assignValueById(activities, 15),
        title: 'Instalaciones de Salud y Desarrollo',
      };
      const otherInstalationsActivities = {
        properties: await assignValueById(activities, 16),
        title: 'Otras Instalaciones',
      };

      const instalations = await assignValueById(activities, 11);
      setInstalationActivities(instalations);

      if (playFacilitiesActivities.length === 0
        && educationalFacilitiesActivities.length === 0
        && sportFAcilitiesActivities.length === 0
        && healthAndDevelopmentInstalationsActivities.length === 0
        && otherInstalationsActivities.length === 0
      ) {
        setUseAllActivities(null);
      } else {
        setUseAllActivities([
          educationalFacilitiesActivities,
          playFacilitiesActivities,
          sportFAcilitiesActivities,
          healthAndDevelopmentInstalationsActivities,
          otherInstalationsActivities,
        ]);
      }
    };

    loadActivities();
  }, [activities]);

  useEffect(() => {
    if (!useAllactivities) return;
    setCount(0); // Reset count before recounting
    useAllactivities.forEach((activity) => {
      if (activity.properties.length > 0) {
        setCount((prevCount) => prevCount + 1);
      }
    });
  }, [useAllactivities]);

  if (isFetching) {
    return <>...loading</>;
  }

  if (!count) {
    return <>{' '}</>;
  }

  return (
    <ProfileSection
      title="Instalaciones"
      subtitleLyrics={{
        subtitle: 'Información general sobre las instalaciones de la Institución',
        lyrics: instalationActivities[0]?.description, // Fixed typo in property name
      }}
    >
      <div className={styles.sectionsContainer}>
        {renderListOfActivitiesTypes(useAllactivities)}
      </div>
    </ProfileSection>
  );
}

InstalationsActivities.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};
